import * as Yup from 'yup';
import i18n from '../../../../translations/strings';
export const ValidationEditProfileSchema = Yup.object({
  phone_number: Yup.string()
    .required(i18n.t('common.requiredField'))
    .min(8, i18n.t('editProfile.validNumber')),
  vat_number: Yup.string().required(i18n.t('common.requiredField')).max(11, i18n.t('editProfile.vatNumberValidation')).min(11, i18n.t('editProfile.vatNumberValidation')),
  tax_code: Yup.string().required(i18n.t('common.requiredField')).max(16, i18n.t('editProfile.taxCodeValidation')).min(16, i18n.t('editProfile.taxCodeValidation')),
  business_name: Yup.string().required(i18n.t('common.requiredField')),
  business_address: Yup.string().required(i18n.t('common.requiredField')),
  business_unique_code: Yup.string().notRequired().test("uniqueCodeTest", i18n.t('registration.pecUniqueCodeValidation'), function (value, context) {
    return !( !context.parent.business_email && !value );
  }).test("uniqueCodeTestLength", i18n.t('registration.uniqueCodeValidation'), function (value, context) {
    if (value && value?.length >= 6 && value?.length <= 7) {
      return true
    }
  }),
  business_email: Yup.string().test("pecTest", i18n.t('registration.pecUniqueCodeValidation'), function (value, context) {
    return !( !context.parent.business_unique_code && !value );
  }).email(i18n.t('common.validEmail')),
});
